import { useEffect, useState } from "react";

/**
 * A value that settles before it is used.
 *
 * <p>Without it every keystroke is a request, so typing "payment" fires seven — and the answers
 * can arrive out of order, leaving the list showing matches for "paym".
 */
export function useDebounced<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setSettled(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
